export const metaPixelId = '1146021761717159'

// Clave donde se guarda la preferencia de seguimiento del visitante.
// Si algún día agregas un aviso de cookies, guarda aquí 'granted' o 'denied'.
export const trackingConsentKey = 'jseefect-tracking-consent'
